// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Enoza","title":"Header_title__17FnV","side":"Header_side__1y7uz"};